import { updates } from '@/mocks/homeData';

export default function Updates() {
  return (
    <section id="updates" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-900">
              最新快讯
            </h2>
            <p className="text-sm text-foreground-500 mt-2">
              实时滚动更新，吃瓜第一手每日最新爆料
            </p>
          </div>

          <div className="relative">
            <div className="absolute left-[19px] top-2 bottom-2 w-0.5 bg-background-200"></div>

            <div className="space-y-0">
              {updates.map((item, idx) => (
                <div key={idx} className="relative flex items-start gap-5 pb-5 last:pb-0">
                  <div className={`relative z-10 flex-shrink-0 w-[38px] h-[38px] flex items-center justify-center rounded-full border-2 ${
                    item.tag === '爆'
                      ? 'bg-primary-100 border-primary-300 text-primary-600'
                      : item.tag === '热'
                      ? 'bg-accent-100 border-accent-300 text-accent-600'
                      : item.tag === '新'
                      ? 'bg-secondary-100 border-secondary-300 text-secondary-600'
                      : 'bg-background-200 border-background-300 text-foreground-500'
                  }`}>
                    <i className={`text-base ${
                      item.tag === '爆' ? 'ri-flashlight-line' :
                      item.tag === '热' ? 'ri-fire-line' :
                      item.tag === '新' ? 'ri-sparkling-line' :
                      'ri-record-circle-line'
                    }`}></i>
                  </div>

                  <div className="flex-1 pt-1.5">
                    <div className="flex flex-wrap items-center gap-2 mb-1">
                      <span className="text-xs text-foreground-500">{item.time}</span>
                      {item.tag && (
                        <span className={`px-1.5 py-0.5 rounded text-[10px] font-medium whitespace-nowrap ${
                          item.tag === '爆'
                            ? 'bg-primary-100 text-primary-700'
                            : item.tag === '热'
                            ? 'bg-accent-100 text-accent-700'
                            : item.tag === '新'
                            ? 'bg-secondary-100 text-secondary-700'
                            : ''
                        }`}>
                          {item.tag === '爆' ? '重磅' : item.tag === '热' ? '热门' : item.tag === '新' ? '最新' : ''}
                        </span>
                      )}
                    </div>
                    <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
                      {item.content}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}